module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wod-program-page"
  }, [_c('div', {
    staticClass: "foo wod-program-page__header"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_wod')))])], 1), _vm._v(" "), (_vm.hasProgramError) ? _c('div', {
    staticClass: "wod-program-page__expired-message"
  }, [_vm._v("\n      " + _vm._s(_vm.programErrorMessage) + "\n    ")]) : (_vm.membershipExpired) ? _c('div', {
    staticClass: "wod-program-page__expired-message"
  }, [_vm._v("\n      " + _vm._s(_vm.locale.t('label_please_extend_membership')) + "\n    ")]) : [_c('div', {
    staticClass: "wod-navigation wod-program-page__nav"
  }, [_c('div', {
    staticClass: "wod-arrow",
    on: {
      "click": function($event) {
        return _vm.changeWeek(-1)
      }
    }
  }, [_c('i', {
    staticClass: "ti-arrow-circle-left"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDate),
      expression: "selectedDate"
    }],
    ref: "dateInput",
    staticStyle: {
      "position": "absolute",
      "opacity": "0",
      "width": "120px",
      "height": "40px"
    },
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.selectedDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedDate = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isMobile()) ? _c('div', {
    staticClass: "wod-program-page__date-trigger",
    on: {
      "click": function($event) {
        return _vm.openDatePicker()
      }
    }
  }, [_c('p', [_c('u', [_vm._v(_vm._s(_vm.currentWeek))])])]) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('div', {
    staticClass: "wod-program-page__date-trigger",
    on: {
      "click": function($event) {
        return _vm.openDatePicker()
      }
    }
  }, [_c('p', [_c('u', [_vm._v(_vm._s(_vm.currentWeek))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wod-program-page__date-icon",
    on: {
      "click": function($event) {
        return _vm.openDatePicker()
      }
    }
  }, [_c('i', {
    staticClass: "ti-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wod-arrow",
    on: {
      "click": function($event) {
        return _vm.changeWeek(1)
      }
    }
  }, [_c('i', {
    staticClass: "ti-arrow-circle-right"
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "center-wrapper"
  }, [_c('my-loader', {
    staticClass: "centered-div"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "wod-container wod-program-page__grid"
  }, _vm._l(([0]), function(item) {
    return (_vm.week != null && _vm.week.length > 0) ? _c('div', {
      staticClass: "wod-program-item wod-program-page__card"
    }, [_c('div', {
      staticClass: "wod-header wod-program-page__day-header"
    }, [_vm._v(_vm._s(_vm.getDayFromDate(_vm.week[item].date)))]), _vm._v(" "), (_vm.week[item].details != null && _vm.week[item].details.length > 0 && _vm.showWodResults) ? _c('div', {
      staticClass: "personal-button-selected wod-program-page__primary-btn",
      on: {
        "click": function($event) {
          return _vm.seeResultsForTraining(_vm.week[item].details[0])
        }
      }
    }, [_c('i', {
      staticClass: "ti-view-list"
    }), _c('span', {
      staticClass: "wod-program-page__btn-text"
    }, [_vm._v(" " + _vm._s(_vm.locale.t('label_see_all_results')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.week[item].details), function(detailsItem, index) {
      return _c('div', {
        staticClass: "wod-content"
      }, [(index === 0 || _vm.getName(detailsItem) !== _vm.getName(_vm.week[item].details[index - 1])) ? _c('div', {
        staticClass: "wod-program-page__training-title"
      }, [_vm._v("\n            " + _vm._s(_vm.getName(detailsItem)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "wod-program-page__category"
      }, [_c('b', [_vm._v(_vm._s(detailsItem.category))])]), _vm._v(" "), _vm._l((_vm.getLongDesc(detailsItem).split('<hr>')), function(innerText, index) {
        return _c('div', {
          staticClass: "wod-program-page__longdesc-wrap"
        }, [_c('p', {
          staticClass: "wod-program-page__longdesc"
        }, [_vm._v(_vm._s(innerText))]), _vm._v(" "), (index < _vm.getLongDesc(detailsItem).split('<hr>').length - 1) ? _c('p', {
          staticClass: "wod-separator-interrupted"
        }) : _vm._e()])
      }), _vm._v(" "), (detailsItem.coachNotes != null && _vm.role !== 'ROLE_USER') ? _c('div', [_vm._v("---------------")]) : _vm._e(), _vm._v(" "), (detailsItem.coachNotes != null && _vm.role !== 'ROLE_USER') ? _c('div', {
        staticClass: "wod-program-page__coach-notes"
      }, [_vm._v(_vm._s(_vm.locale.t('label_wod_coach_notes')) + ": " + _vm._s(detailsItem.coachNotes))]) : _vm._e(), _vm._v(" "), (detailsItem.collapsed == null || detailsItem.collapsed === false) ? _c('div', {
        staticClass: "wod-program-page__results-shell"
      }, [_c('div', {
        staticClass: "wod-program-page__results-list"
      }, _vm._l((detailsItem.resultRounds), function(i) {
        return _c('div', {
          key: i,
          staticClass: "set-container wod-program-page__set-row"
        }, [_c('span', {
          staticClass: "wod-program-page__set-label"
        }, [_vm._v(_vm._s(_vm.locale.t('label_result_set')) + " #" + _vm._s(i))]), _vm._v(" -\n                "), (_vm.isMeasureTime(detailsItem.resultMeasure)) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (detailsItem.results[i - 1].min),
            expression: "detailsItem.results[i-1].min"
          }],
          staticClass: "weight-input wod-program-page__time-input",
          attrs: {
            "type": "number",
            "placeholder": "min"
          },
          domProps: {
            "value": (detailsItem.results[i - 1].min)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(detailsItem.results[i - 1], "min", $event.target.value)
            }
          }
        }), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (detailsItem.results[i - 1].sec),
            expression: "detailsItem.results[i-1].sec"
          }],
          staticClass: "weight-input wod-program-page__time-input",
          attrs: {
            "type": "number",
            "placeholder": "sec"
          },
          domProps: {
            "value": (detailsItem.results[i - 1].sec)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(detailsItem.results[i - 1], "sec", $event.target.value)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (detailsItem.results[i - 1] != null && !_vm.isMeasureTime(detailsItem.resultMeasure)) ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (detailsItem.results[i - 1].weight),
            expression: "detailsItem.results[i-1].weight"
          }],
          staticClass: "weight-input wod-program-page__weight-input",
          attrs: {
            "type": "number",
            "placeholder": _vm.getPlaceholderTypeByMeasure(detailsItem.resultMeasure)
          },
          domProps: {
            "value": (detailsItem.results[i - 1].weight)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(detailsItem.results[i - 1], "weight", $event.target.value)
            }
          }
        }) : _vm._e(), _vm._v(" "), (!_vm.isMeasureTime(detailsItem.resultMeasure)) ? _c('span', {
          staticClass: "wod-program-page__measure-label"
        }, [_vm._v(" " + _vm._s(detailsItem.resultMeasure))]) : _vm._e()])
      }), 0), _vm._v(" "), _c('div', {
        staticClass: "wod-program-page__results-actions"
      }, [(!detailsItem.isLoadingResults && _vm.isAllResultSet(detailsItem) && detailsItem.resultRounds != null && detailsItem.resultRounds > 0) ? _c('div', {
        staticClass: "personal-button-selected wod-program-page__primary-btn",
        on: {
          "click": function($event) {
            return _vm.saveResults(detailsItem)
          }
        }
      }, [_c('i', {
        staticClass: "ti-save"
      }), _c('span', {
        staticClass: "wod-program-page__btn-text"
      }, [_vm._v(" " + _vm._s(_vm.locale.t('label_save')))])]) : _vm._e(), _vm._v(" "), (!detailsItem.isLoadingResults && !_vm.isAllResultSet(detailsItem) && detailsItem.resultRounds != null && detailsItem.resultRounds > 0) ? _c('div', {
        staticClass: "personal-button-selected-disabled wod-program-page__disabled-btn"
      }, [_c('i', {
        staticClass: "ti-save"
      }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n              ")]) : _vm._e(), _vm._v(" "), (detailsItem.isLoadingResults) ? _c('div', {
        staticClass: "wod-program-page__loader-wrap"
      }, [(detailsItem.isLoadingResults) ? _c('my-loader') : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (detailsItem.resultRounds != null && detailsItem.resultRounds > 0) ? _c('div', {
        staticClass: "flex-container wod-program-page__change-wrap"
      }, [_c('div', {
        staticClass: "personal-button-selected wod-program-page__primary-btn",
        on: {
          "click": function($event) {
            return _vm.updateCollapsed(detailsItem)
          }
        }
      }, [_c('i', {
        staticClass: "ti-pencil"
      }), _c('span', {
        staticClass: "wod-program-page__btn-text"
      }, [_vm._v(" " + _vm._s(_vm.locale.t('label_change_my_result')))])])]) : _vm._e(), _vm._v(" "), (_vm.week[item].details.length > 1 && index < _vm.week[item].details.length - 1) ? _c('p', {
        staticClass: "wod-separator"
      }) : _vm._e()], 2)
    })], 2) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wod-program-page__spacer"
  }), _vm._v(" "), _c('add-training-of-the-day-wod', {
    attrs: {
      "show": _vm.showAddDefinition,
      "date": _vm.addDefinitionDate,
      "type": 'WOD',
      "data": _vm.definitionDataToEdit
    }
  }), _vm._v(" "), _c('choose-training-definition-modal', {
    attrs: {
      "show": _vm.showChooseDefinition,
      "date": _vm.chooseDefinitionDate,
      "type": 'WOD'
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ed480c94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wod/WodProgram.vue
// module id = 858
// module chunks = 0